export default "__VITE_ASSET__3470880b__"